export const RATE_LABELS: Record<string, string> = {
  labor_avoid: "Deterrent",
  labor_professional: "Professional",
  labor_educational: "Educational",
  labor_preferred: "Preferred",
  per_diem_daily: "Per diem (daily)",
  airfare_default: "Airfare (default)",
  mileage_per_mile: "Mileage",
  rental_car_daily: "Rental car (daily)",
  ten_hour_day_multiplier: "10-hour day multiplier",
};
